import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: "DeleteRoleOverlay",
    setup(){
        const store = useStore()
        const isSubmitting = computed(()=> store.state.frivilligprofil.is_submitting)
        const groupRoleId = computed(() => store.state.main.page_overlay_content_data.groupRoleId)

        const submitConfirmDelete = () => {
            store.dispatch("frivilligprofil/deleteRolletildeling", groupRoleId.value);
        };

        const closeOverlay = function() {
            store.dispatch('main/closePageOverlay')
        }

        const handleRegret = () => {
            closeOverlay()   
        };

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'DeleteRoleOverlay', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            isSubmitting,
            getLabel,
            handleRegret,
            submitConfirmDelete
        }
        
    }
}